module.exports = __webpack_public_path__ + "static/media/logoGPS.1d8d835e.svg";